const { resolveDisplayedSalesReps } = require("../../../../../../../utils/displayedSalesRepResolution");
const { isAdministratorRole } = require("../../../../../../../utils/instanceRoleInheritance");

const ROLE_GROUPS = [
  { role: "client-rep", label: "Client Rep" },
  { role: "order-rep", label: "Order Rep" },
  { role: "purchasing-rep", label: "Purchasing" },
];

const normalizeRole = (role) =>
  String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "-");

const normalizeId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : String(value || "");
};

const uniqueById = (users = []) => {
  const seen = new Set();
  return users.filter((user) => {
    const id = normalizeId(user?.id);
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};

const usersWithRole = (assignedUsers = [], role) =>
  uniqueById((assignedUsers || []).filter((user) => normalizeRole(user?.role) === role));

const resolveAssignedUserRoleGroups = (assignedUsers = []) => {
  const orderReps = usersWithRole(assignedUsers, "order-rep");
  const clientReps = usersWithRole(assignedUsers, "client-rep");
  const administrators = uniqueById(
    (assignedUsers || []).filter((user) =>
      isAdministratorRole(user?.role)
    )
  );
  const purchasingReps = usersWithRole(assignedUsers, "purchasing-rep");

  const { clientReps: resolvedClientReps, orderReps: resolvedOrderReps } =
    resolveDisplayedSalesReps({ clientReps, orderReps, administrators });

  return ROLE_GROUPS.map((group) => {
    if (group.role === "order-rep") return { ...group, users: resolvedOrderReps };
    if (group.role === "client-rep") return { ...group, users: resolvedClientReps };
    return { ...group, users: purchasingReps };
  });
};

module.exports = {
  ROLE_GROUPS,
  normalizeRole,
  resolveAssignedUserRoleGroups,
};
